import React from 'react';

const UIInputText = ({
  label = '',
  setValue,
  value
}) => (
  <div className="w-full">
    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">{label}</label>
    <input
      className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
      type="text"
      onChange={e => setValue(e.target.value)}
      value={value}
    />
  </div>
)

export default UIInputText;